module.exports = __webpack_public_path__ + "img/d-2.7f795d7f.png";